import { Box, chakra, Flex, Text } from '@chakra-ui/react';
import useOrderTimeLabel from 'hooks/modules/order/useOrderTimeLabel';
import useAppTheme from 'hooks/shared/useAppTheme';
import { DirectionType, Recommendation } from 'model/modules/portfolio/rebalance';
import AppCard from 'presentation/components/shared/card/AppCard';
import CardInfoRow from 'presentation/components/shared/card/CardInfoRow';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  rec: Recommendation;
  createdAt: Date;
}

const RebalanceGridItem: FC<Props> = ({ rec, createdAt, ...props }) => {
  const { t } = useTranslation();
  const orderTimeLabel = useOrderTimeLabel();
  const theme = useAppTheme();
  const statusColor = theme.colors[Color.Primary500];

  return (
    <AppCard
      w="calc(50% - 10px)"
      display="flex"
      flexDirection="column"
      {...props}
    >
      <Flex
        borderTopRadius="15px"
        justifyContent="space-between"
        px="20px"
        py="10px"
        bgColor={statusColor}
        h="100px"
      >
        <Text
          alignSelf="flex-end"
          noOfLines={2}
          fontSize={30}
          color="#fff"
          fontWeight={700}
        >
          {rec.ticker}
        </Text>
        <Text
          noOfLines={1}
          textAlign="right"
          minW="60px"
          fontSize={24}
          color="#fff"
          fontWeight={700}
        >
          {orderTimeLabel(createdAt)}
        </Text>
      </Flex>
      <Flex
        p="15px"
        flex="1"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box mb="15px">
          <CardInfoRow label={t('peFinanceHistoryType')}>
            <Text>{rec.direction === DirectionType.Buy ? t('orderBuyAction') : t('orderSellAction')}</Text>
          </CardInfoRow>
          <CardInfoRow label={t('recommendedOrderQuantity')}>
            <Text>{rec.quantity}</Text>
          </CardInfoRow>
          <CardInfoRow label={t('orderAmount')}>
            <Text>{rec.amount}</Text>
          </CardInfoRow>
          <CardInfoRow label={t('orderPrice')} showBorder={false}>
            <Text>{rec.price} {rec.currency.symbol}</Text>
          </CardInfoRow>
        </Box>
      </Flex>
    </AppCard>
  );
};

export default chakra(RebalanceGridItem);
